module.exports = __webpack_public_path__ + "static/dinotowel-9692d64f9e5eb287fe0d41991ca7a2ea.png";